import React, {Component} from 'react';
import toastr from "toastr";
import _ from 'lodash';
import $ from 'jquery';
import {getJwt} from '../../../services/authService';

import * as authService from "../../../services/authService";
import http from "../../../services/httpService";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import {paginate} from '../../utils/paginate_posts'
import PaginationSmall from '../../common/PaginationSmall'
import ItemsPerPage from '../../common/ItemsPerPage';
import TableNoData from '../../common/TableNoData';
import CampaignsTable from '../CampaignsTable';

import Loader from '../../utils/loader'
import ReactGA from "react-ga";

const optionsPageSize = [
    // {value: 3, text: 3},
    {value: 5, text: 5},
    {value: 10, text: 10},
    {value: 25, text: 25},
    {value: 50, text: 50},
    {value: 100, text: 100}
];

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class FBAdsCampaignPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            totalCampaigns: 0,
            total_subscribers: 0,
            push_subscribers: [],
            pageSize: 10,
            currentPage: 1,
            paging: '',
            selectedAdAccount: '',
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            loader: false,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            fbAdsManagementPermission: false
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    
    openModal = () => {

    }

    async componentDidMount() {
        
        if (this.props.fbAdsManagementPermission !== this.state.fbAdsManagementPermission) {
            this.setState({fbAdsManagementPermission: this.props.fbAdsManagementPermission})
        }
        if (this.props.user.add_account_id) {
            try {
                this.setState({loader: true});
                const pageSize = this.state.pageSize;

                const result = await http.get(facebook_app_marketing_url + this.props.user.add_account_id + '/campaigns?access_token=' + this.props.user.user_fb_extended_token +
                    '&fields=id,account_id,name,spend_cap,budget_remaining,configured_status,daily_budget,lifetime_budget,' +
                    'adsets,promoted_object,status,objective,stop_time,update_time,insights{unique_clicks,cpm,impressions,reach,cpc,' +
                    'ctr,date_stop}&level=campaign&limit=' + this.state.pageSize + '&summary=total_count&sort=date_start_descending&date_preset=lifetime' +
                    '&filtering=[{"field":"objective","operator":"IN","value":["' + this.state.selectedCampaignPerformance + '"]}]', {headers: {authorization: getJwt()}})

                // const result = await http.get('https://graph.facebook.com/v4.0/act_' + accountId + '/campaigns?access_token=' + accessToken +
                //     '&fields=id,account_id,name,spend_cap,budget_remaining,configured_status,daily_budget,lifetime_budget,' +
                //     'adsets,promoted_object,status,objective,stop_time,update_time,insights{unique_clicks,cpm,impressions,reach,cpc,' +
                //     'ctr,date_stop}&level=campaign&limit='+ this.state.pageSize +'&summary=total_count&sort=date_start_descending&date_preset=lifetime' +
                //     '&filtering=[{"field":"objective","operator":"IN","value":["' + this.state.selectedCampaignPerformance + '"]}]')

                // const result2 = await http.get('https://graph.facebook.com/v4.0/act_' + accountId + '/insights?access_token=' + accessToken +
                //     '&fields=account_id,campaign_id,objective,campaign_name,cpm,cpp,actions,cost_per_action_type,impressions,reach&' +
                //     'level=campaign&limit='+ this.state.pageSize +'&sort=date_start_descending&date_preset=lifetime' +
                //     '&filtering=[{"field":"objective","operator":"IN","value":["' + this.state.selectedCampaignPerformance + '"]}]')

                const data = result.data.data;
                const paging = result.data.paging;
                const summary = result.data.summary;

                if (!data) {
                    toastr.error("User id does not match. :(  Please log in again.");
                    this.props.history.push('/logout');
                }


                    this.setState({
                        campaigns: data,
                        paging,
                        totalCampaigns: summary.total_count,
                        loader: false,
                        selectedAdAccount: this.props.user.add_account_id,
                        selectedCampaignPerformance: this.props.selectedCampaignPerformance
                    });

            } catch (ex) {
                this.setState({loader: false})
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }

        this.getPreview();
    }



    componentDidUpdate=()=> {
        if (this.state.selected_source !== this.props.selected_source) {

            this.handlePageChange(1, this.props.selected_source, "all");
        }
        if (this.state.fbAdsManagementPermission !== this.props.fbAdsManagementPermission) {
            if (this.props.fbAdsManagementPermission) {
                this.getCampaigns()
            }
            this.setState({fbAdsManagementPermission: this.props.fbAdsManagementPermission})
        }

        if (this.state.selectedAdAccount !== this.props.user.add_account_id) {
            this.setState({
                selectedAdAccount: this.props.user.add_account_id
            })
            this.getCampaigns()
        }
        this.getPreview();
        if (this.state.selectedCampaignPerformance !== this.props.selectedCampaignPerformance) {
            this.setState({
                selectedCampaignPerformance: this.props.selectedCampaignPerformance
            })
            this.getCampaigns()
        }
    }



    handlePageChange = async (page) => {
        let beforeAfter = page < this.state.currentPage ? 'before' : 'after';
        // console.log('Ovo je beforeAfter: ', beforeAfter)
        await this.setState({currentPage: page});
        try {
            this.setState({loader: true});
            const result = await http.get(facebook_app_marketing_url + this.props.user.add_account_id + '/campaigns?access_token=' + this.props.user.user_fb_extended_token +
                '&fields=id,account_id,name,spend_cap,budget_remaining,configured_status,daily_budget,lifetime_budget,' +
                'adsets,promoted_object,status,objective,stop_time,update_time,insights{unique_clicks,cpm,impressions,reach,cpc,' +
                'ctr,date_stop}&level=campaign&limit=' + this.state.pageSize + '&summary=total_count&sort=date_start_descending&date_preset=lifetime&' +
                '&filtering=[{"field":"objective","operator":"IN","value":["' + this.state.selectedCampaignPerformance + '"]}]&' +
                (beforeAfter === 'before' ? ('before=' + this.state.paging.cursors.before) : ('after=' + this.state.paging.cursors.after), {headers: {authorization: getJwt()}})
            )
            const data = result.data.data;
            const paging = result.data.paging;
            const summary = result.data.summary;

            await this.setState({
                campaigns: data,
                paging,
                totalCampaigns: summary.total_count,
                loader: false
            });
            this.setState({loader: false});
        } catch (ex) {
            this.setState({loader: false})
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    };

    selectCampaignPerformanceOption = async (selected) => {
        await this.setState({
            selectedCampaignPerformance: selected
        })
        try {
            this.setState({loader: true});

            const result = await http.get(facebook_app_marketing_url + this.props.user.add_account_id + '/campaigns?access_token=' + this.props.user.user_fb_extended_token +
                '&fields=id,account_id,name,spend_cap,budget_remaining,configured_status,daily_budget,lifetime_budget,' +
                'adsets,promoted_object,status,objective,stop_time,update_time,insights{unique_clicks,cpm,impressions,reach,cpc,' +
                'ctr,date_stop}&level=campaign&limit=' + this.state.pageSize + '&summary=total_count&sort=date_start_descending&date_preset=lifetime' +
                '&filtering=[{"field":"objective","operator":"IN","value":["' + this.state.selectedCampaignPerformance + '"]}]', {headers: {authorization: getJwt()}})

            const data = result.data.data;
            const paging = result.data.paging;
            const summary = result.data.summary;

            if (!data) {
                toastr.error("User id does not match. :(  Please log in again.");
                this.props.history.push('/logout');
            }
            await this.setState({
                campaigns: data,
                paging,
                totalCampaigns: summary.total_count,
                currentPage: 1,
                loader: false
            });
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }

    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            pageSize: value
        })
        try {
            this.setState({loader: true});

            const result = await http.get(facebook_app_marketing_url + this.props.user.add_account_id + '/campaigns?access_token=' + this.props.user.user_fb_extended_token +
                '&fields=id,account_id,name,spend_cap,budget_remaining,configured_status,daily_budget,lifetime_budget,' +
                'adsets,promoted_object,status,objective,stop_time,update_time,insights{unique_clicks,cpm,impressions,reach,cpc,' +
                'ctr,date_stop}&level=campaign&limit=' + this.state.pageSize + '&summary=total_count&sort=date_start_descending&date_preset=lifetime' +
                '&filtering=[{"field":"objective","operator":"IN","value":["' + this.state.selectedCampaignPerformance + '"]}]', {headers: {authorization: getJwt()}})

            const data = result.data.data;
            const paging = result.data.paging;
            const summary = result.data.summary;

            // console.log('Daj mi te kampanje: ', summary.total_count, paging, data)

            await this.setState({
                campaigns: data,
                paging,
                totalCampaigns: summary.total_count,
                loader: false
            });
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }

    getCampaigns = async () => {
        if (this.props.fbAdsManagementPermission) {
            try {
                const add_account_id = await this.props.user.add_account_id;
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/campaigns?access_token=' + this.props.user.user_fb_extended_token +
                    '&fields=id,account_id,name,spend_cap,budget_remaining,configured_status,daily_budget,lifetime_budget,' +
                    'adsets,promoted_object,status,objective,stop_time,update_time,insights{unique_clicks,cpm,impressions,reach,cpc,' +
                    'ctr,date_stop}&level=campaign&limit=' + this.state.pageSize + '&summary=total_count&sort=date_start_descending&date_preset=lifetime' +
                    '&filtering=[{"field":"objective","operator":"IN","value":["' + this.state.selectedCampaignPerformance + '"]}]', {headers: {authorization: getJwt()}})

                const data = result.data.data;
                const paging = result.data.paging;
                const summary = result.data.summary;

                if (!data) {
                    toastr.error("User id does not match. :(  Please log in again.");
                    this.props.history.push('/logout');
                }


                    this.setState({
                        campaigns: data,
                        paging,
                        totalCampaigns: summary.total_count,
                    });

            } catch (ex) {
                this.setState({loader: false})
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
    }

    getPreview = async () => {
        if (!this.state.preview) {
            try {
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';
                const campaign = await this.state.campaigns[0] || {};
                const link = 'https://nba.com';
                let object_story_spec = {
                    "page_id": 106911734110630,
                    "link_data": {
                        "call_to_action": {
                            "type": "USE_APP",
                            "value": {
                                "link": link
                            }
                        },
                        "description": "Ovde ide opis",
                        "link": link,
                        "message": "Probna Poruka",
                        "name": "Ovde ide ime",
                        "picture": link
                    }
                }
                const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                    '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}', {headers: {authorization: getJwt()}})

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch (e) {
                //console.log('error: ', e)
            }
        }

    }

    responseFacebookForSource = async () => {
        this.props.checkPermissions()
    };

    noFbAdsRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img alt='No facebook ads' src="/img/emptyStates/url_shortener_my_campaigns.gif"/>
            <h3>There is no data for Facebook Ads.</h3>
            {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
            <div className='flex-direction-row justify-content-center'>
                {this.props.selectedCampaignPerformance === 'MESSAGES' ?
                    <button
                        onClick={ () =>  this.props.history.push('/new/fb-campaigns') }
                        className=' btn-action margin-bottom-10'>
                        Start Facebook Ads Campaign
                    </button>
                    :
                    <button
                        onClick={ () => this.props.history.push('/new/acquire-subscribers') }
                        className=' btn-action margin-bottom-10'>
                        Start Facebook Ads Campaign
                    </button>
                }

            </div>
        </div>
    };

    noPermissionsRenderer = () => {
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        return <div className='no-contacts-container panel-container margin-top-20'>
            <img alt='Not allowed' src="/img/emptyStates/url_shortener_my_campaigns.gif"/>
            {
                <h3>Facebook Ads Manager is not connected to {this.props.selectedSourceName}.</h3>
            }
            {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
            <div className='flex-direction-row justify-content-center'>
                <FacebookLogin
                    appId={facebook_app_id}
                    autoLoad={false}
                    return_scopes={true}
                    fields="name, email, picture"
                    scope="ads_management"
                    callback={this.responseFacebookForSource}
                    render={renderProps => (

                        <button
                            id="ask_denied_permissions"
                            onClick={renderProps.onClick}
                            className='btn-action margin-bottom-10'
                        >
                            Give Ads Manager Permission
                        </button>
                    )}/>
            </div>
        </div>
    };

    render() {
        const {pageSize, currentPage, sortColumn, searchQuery, sub_type, type_of_subscription, total_subscribers} = this.state;
        let {
            subscribers: subscribersAll,
            //push_subscribers: subscribersPush
        } = this.state;


        let filtered = subscribersAll;
        if (searchQuery) {
            if (sub_type) {
                filtered = subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(searchQuery.toLowerCase()));
            }
        }
        const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
        const campaigns = paginate(sorted, currentPage, pageSize);
//console.log("subscribers subscribers subscribers ", subscribers);
        return (
            <React.Fragment>
                {/*<h3>Campaign performance</h3>*/}
                {/*<div className="separator"></div>*/}
                <div className="d-block">
                    {/*{ this.state.preview ? <div dangerouslySetInnerHTML={{ __html: this.state.preview }} /> : null }*/}
                    {/*<div className="posts-filtering subscribers-filtering campaigns-per-page-container m-m-b">*/}
                    {/*<div className="row flex-direction-row flex-small-direction-column">*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {

                        (this.state.loader ?
                                <Loader/> :
                                <div style={{marginTop: 20}}>
                                    {
                                        this.props.fbAdsManagementPermission ?
                                            this.state.campaigns && (this.state.campaigns.length > 0) ?
                                                <CampaignsTable
                                                    campaigns={this.state.campaigns}
                                                    onClick={this.handleClick}
                                                    onSort={this.handleSort}
                                                    sortColumn={sortColumn}
                                                    // accountId={ accountId }
                                                    // accessToken={accessToken}
                                                    accessToken={this.props.user.user_fb_extended_token}
                                                    getCampaigns={() => this.getCampaigns()}
                                                />
                                                :
                                                this.noFbAdsRenderer()
                                            :
                                            this.noPermissionsRenderer()
                                    }
                                </div>
                        )
                    }
                    {this.state.campaigns && (this.state.campaigns.length > 0) && !this.state.loader ?
                        <div className="subscribers-shown" style={{marginTop: -40}}>
                            <PaginationSmall
                                itemsCount={this.state.totalCampaigns}
                                pageSize={this.state.pageSize}
                                currentPage={currentPage}
                                onPageChange={this.handlePageChange}/>
                            <ItemsPerPage
                                handleItemChange={item => this.handleChangeCampaignsNumberPerPage(item.value)}
                                selectedPageSize={this.state.pageSize}
                            />
                        </div>
                        :
                        ''
                    }
                </div>

            </React.Fragment>
        )
    }
}

export default FBAdsCampaignPerformance